import React, { useState } from 'react';
import { Text, toast } from '@getpingback/realeza';
import { Accordion, AccordionDetails, AccordionSummary, Button } from '@material-ui/core';
import { PlusIcon, PencilSingleIcon, TrashCanIcon } from '@stash-ui/regular-icons';
import Lesson from './Lesson';
import NewLessonModal from './NewLessonModal';
import DeleteModal from './DeleteModal';
import { deleteLesson } from '../../../services/education';

const ModuleSection = ({ name, lessons, onClick, courseId, moduleId, onSave, onDelete }) => {
  const [isNewLessonModalOpen, setIsNewLessonModalOpen] = useState({
    isOpen: false,
    lessonId: null,
  });
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState({
    isOpen: false,
    lessonId: null,
  });

  const handleDeleteLesson = async lessonId => {
    try {
      await deleteLesson(lessonId);
      setIsDeleteModalOpen({ isOpen: false, lessonId: null });
      onSave();
      toast.success('Lesson deleted successfully');
    } catch (error) {
      console.error(error);
      toast.error(`Error deleting lesson: ${error?.response?.data?.error?.message}`);
    }
  };

  return (
    <Accordion className="education__course__modules__list__accordion">
      <AccordionSummary>
        <div className="education__course__modules__list__accordion__summary">
          <Text size={16} weight="bold" color="white">
            {name}
          </Text>
          <div>
            <Button variant="contained" onClick={onClick}>
              <PencilSingleIcon color="#fafafa" />
            </Button>
            <Button variant="contained" color="secondary" onClick={onDelete}>
              <TrashCanIcon color="#f96e6eb2" />
            </Button>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div className="education__course__lessons">
          <div className="education__course__lessons__add">
            <h1>Lessons</h1>
            <Button variant="contained" startIcon={<PlusIcon />} onClick={() => setIsNewLessonModalOpen({ isOpen: true, lessonId: null })}>
              Add Lesson
            </Button>
          </div>
          {lessons?.map(lesson => (
            <Lesson
              key={lesson.id}
              lesson={lesson}
              onEditLesson={() => setIsNewLessonModalOpen({ isOpen: true, lessonId: lesson.id })}
              onDelete={() => setIsDeleteModalOpen({ isOpen: true, lessonId: lesson.id })}
            />
          ))}
        </div>
      </AccordionDetails>

      <NewLessonModal
        isOpen={isNewLessonModalOpen.isOpen}
        onClose={() => setIsNewLessonModalOpen({ isOpen: false, lessonId: null })}
        lessonId={isNewLessonModalOpen.lessonId}
        courseId={courseId}
        moduleId={moduleId}
        onSave={onSave}
      />

      <DeleteModal
        isOpen={isDeleteModalOpen.isOpen}
        onClose={() => setIsDeleteModalOpen({ isOpen: false, lessonId: null })}
        onDelete={() => handleDeleteLesson(isDeleteModalOpen.lessonId)}
        title="Delete Lesson"
        message="Are you sure you want to delete this lesson?"
      />
    </Accordion>
  );
};

export default ModuleSection;
